<template>
    <v-container fluid>

        <v-row justify="center" class="mb-12">
            <v-col
                    sm="10"
                    cols="12"
            >
                <v-stepper
                        v-model="stepValue"
                >
                    <template >
                        <v-stepper-header >
                            <v-stepper-step :complete="stepValue > 1" step="1">查找监控对象</v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step :complete="stepValue > 2" step="2">查询节点历史信息</v-stepper-step>
                        </v-stepper-header>
                    </template>

                    <v-stepper-items>
                        <v-stepper-content :step="1">
                            <v-form ref="queryEqpData">
                                <v-row justify="center">
                                    <v-col
                                            md="4"
                                            sm="6"
                                            cols="12">
                                        <Z-Source-Selecton label="请选择医院"
                                                           :source="'HospSelector'"
                                                           v-model="queryEqpData.hospId">
                                        </Z-Source-Selecton>
                                    </v-col>
                                    <v-col
                                            md="4"
                                            sm="6"
                                            cols="12">
                                        <v-text-field
                                                label="设备名称/房间名称"
                                                prepend-inner-icon="search"
                                                clearable
                                                v-model="queryEqpData.queryCondition"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                            md="3"
                                            sm="6"
                                            cols="12">
                                        <v-btn color="primary"
                                               :loading="loading.queryEqp"
                                               @click="queryEqpDataList">
                                            查找监控对象
                                        </v-btn>
                                        <v-btn
                                                color="primary"
                                                class="ma-2"
                                                @click="resetEqpQuery">
                                            <v-icon>mdi-refresh</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                            <v-row justify="center">
                                <v-col
                                        cols="11">
                                    <v-card>
                                        <!--<v-card-title>-->
                                        <!--监控对象数据-->
                                        <!--<v-spacer></v-spacer>-->
                                        <!--<v-text-field-->
                                        <!--v-model="eqpSearch"-->
                                        <!--append-icon="mdi-magnify"-->
                                        <!--label="关键字"-->
                                        <!--single-line-->
                                        <!--hide-details-->
                                        <!--&gt;</v-text-field>-->
                                        <!--</v-card-title>-->
                                        <v-data-table
                                                :page.sync="queryEqpData.pagedQueryInfo.index"
                                                :server-items-length="queryEqpData.pagedQueryInfo.sum"
                                                :single-select="true"
                                                show-select
                                                v-model="selectEqp"
                                                :options.sync="eqpTableOptions"
                                                :loading="loading.queryEqp"
                                                :headers="eqpHeaders"
                                                :items="eqpTableData"
                                                :search="eqpSearch">
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-btn
                                    style="margin:auto;display:block;"
                                    color="primary"
                                    @click="goNextPage"
                            >
                                下一步
                            </v-btn>
                        </v-stepper-content>
                        <v-stepper-content :step="2">
                            <span class="font-weight-bold"
                                  v-if="selectEqp.length>0">{{selectEqp[0].businessName}}</span>
                            <v-form ref="queryForm">
                                <v-row justify="start" class="pl-12 pr-12">
                                    <v-col
                                            md="3"
                                            cols="6">
                                        <v-select
                                                v-model="queryData.collectorPlace"
                                                label="请选择采集位置"
                                                item-text="label"
                                                item-value="value"
                                                clearable
                                                :loading="loading.selectPlaceLoading"
                                                :items="selectSearchOptions"
                                        >
                                            <template v-slot:prepend-item>
                                                <v-list-item
                                                        ripple
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            <v-text-field
                                                                    v-model="searchText"
                                                                    append-icon="mdi-magnify"
                                                                    label="Search"
                                                                    single-line
                                                                    hide-details
                                                                    clearable
                                                            ></v-text-field>

                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider class="mt-2"></v-divider>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col
                                            md="2"
                                            cols="6"
                                            align-self="center">
                                        <v-switch v-model="queryData.isWarning" label="预警状态"></v-switch>
                                    </v-col>
                                    <v-col
                                            md="6"
                                            sm="12"
                                            cols="12">
                                        <z-select-date v-model="queryData.date"  :startDates="this.startDateant"  :endDates="this.endDateantL"
                            ></z-select-date>
                                    </v-col>
                                </v-row>
                                <v-row justify="start" class="pl-12 pr-12">
                                    <v-col
                                            md="3"
                                            cols="6"
                                    >

                                        <Z-Source-Selector label="被监控数据类型"
                                                           param="COLLECT_DATA_TYPE"
                                                           source="DicSelector"
                                                           v-model="queryData.collectDataType"></Z-Source-Selector>

                                    </v-col>
                                    <v-col
                                            md="3"
                                            cols="6"
                                            v-if="queryData.collectDataType"
                                    >
                                        <Z-Source-Selector
                                                label="数据检索排序方式"
                                                :initLoad="false"
                                                :itemsList="typeList"
                                                v-model="queryData.collectValueOrder"></Z-Source-Selector>
                                    </v-col>
                                    <v-col
                                            md="3"
                                            cols="6"
                                    >
                                        <Z-Source-Selector label="采集时间排序方式"
                                                           :initLoad="false"
                                                           :itemsList="typeList"
                                                           v-model="queryData.createDateTimeOrder"></Z-Source-Selector>
                                    </v-col>
                                    <v-col
                                            class="text-center"
                                            md="3"
                                            cols="6">
                                        <v-btn color="primary"
                                               :loading="loading.queryRequest"
                                               @click="queryHistoryData">
                                            搜索
                                        </v-btn>
                                        <v-btn
                                                color="primary"
                                                class="ma-2"
                                                @click="resetQuery">
                                            <v-icon>mdi-refresh</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                            <v-row
                                    justify="center">
                                <v-col
                                        cols="11">
                                    <v-card>
                                        <!--<v-card-title>-->
                                        <!--历史数据-->
                                        <!--<v-spacer></v-spacer>-->
                                        <!--<v-text-field-->
                                        <!--v-model="search"-->
                                        <!--append-icon="mdi-magnify"-->
                                        <!--label="关键字"-->
                                        <!--single-line-->
                                        <!--hide-details-->
                                        <!--&gt;</v-text-field>-->
                                        <!--</v-card-title>-->
                                        <v-data-table
                                                :page.sync="queryData.pagedQueryInfo.index"
                                                :server-items-length="queryData.pagedQueryInfo.sum"
                                                :options.sync="tableOptions"
                                                :loading="loading.queryRequest"
                                                :headers="headers"
                                                :items="tableData"
                                                :search="search">
                                            <template v-slot:item.isWarning="{ item }">
                                                {{item.isWarning?'是':'否'}}
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-btn
                                    style="margin:auto;display:block;"
                                    color="primary"
                                    @click="stepValue=1"
                            >
                                返回上一页
                            </v-btn>
                        </v-stepper-content>
                    </v-stepper-items>

                </v-stepper>
            </v-col>
        </v-row>

        <z-notify ref="notify"></z-notify>

    </v-container>
</template>

<script>
  import ZSourceSelecton from "@/components/ZSourceSelecton"
  import ZSourceSelector from "@/components/ZSourceSelector"
  import ZSelectDate from "@/components/ZSelectDate"
  import {
    historyCollectorQuery,
    collectDetailHistoryController
  } from "@/api/historyData"
  import {getSelecotrData} from '@/api/selector'

  export default {
    name: "HistoryData",
    data: () => ({
      stepValue: 1,
	  startDateant:"",
	  endDateantL:'',
	  antcollectorId:null,
      queryEqpData: {
        hospId: '',
        queryCondition: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 10,
          sum: 0
        }
      },
      queryData: {
        collectValueOrder: '',
        createDateTimeOrder: '',
        collectorPlace:'',
        isWarning: false,
        collectDataType: "",
        date: [],
        pagedQueryInfo: {
          index: 1,
          pageSize: 10,
          sum: 0
        }
      },
      isShowStartDateMenu: false,
      isShowEndDateMenu: false,
      isShowTimeMenu: false,
      isShowEndTimeMenu: false,
      loading: {
        queryEqp: false,
        queryRequest: false,
        selectPlaceLoading: false
      },
      selectOptions: [],
      searchText: '',
      search: '',
      eqpSearch: '',
      selectEqp: [],
      eqpTableOptions: {},
      eqpHeaders: [
        {
          text: '设备编号',
          align: 'start',
          sortable: false,
          value: 'hospEqpId'
        },
        {
          text: 'MAC',
          align: 'start',
          sortable: false,
          value: 'collectorMac'
        },
        {
          text: '监控对象',
          align: 'start',
          sortable: false,
          value: 'businessName',
        }
      ],
      eqpTableData: [],
      tableOptions: {},
      headers: [
        {
          text: '节点编号',
          align: 'start',
          sortable: false,
          value: 'sensorSeq',
        },
        {
          text: '采集位置',
          align: 'start',
          sortable: false,
          value: 'collectPlace',
        },
        {
          text: '数据类型',
          align: 'start',
          sortable: false,
          value: 'collectDataType',
        },
        {
          text: '实时数据',
          align: 'start',
          sortable: false,
          value: 'collectValue'
        },
        {
          text: '预警',
          align: 'start',
          sortable: false,
          value: 'isWarning',
        },
        {
          text: '采集时间',
          align: 'start',
          sortable: false,
          value: 'createDateTime'
        },
      ],
      tableData: [],
      typeList: [
        {
          label: '升序',
          value: 'ASC'
        },
        {
          label: '降序',
          value: 'DESC'
        }
      ],
    }),
    components: {
      ZSourceSelector,
      ZSelectDate,
	  ZSourceSelecton
    },
    computed: {
      selectSearchOptions: {
        get() {
          if (this.searchText) {
            return this.selectOptions.filter(i => i.label.indexOf(this.searchText) != -1)
          } else {
            return this.selectOptions
          }
        }
      }
    },
    watch: {
      'queryData.collectDataType':{
        handler(val,old){
            this.queryData.collectValueOrder='';
        }
      },
      eqpTableOptions: {
        handler(val, old) {
          console.log(val, '设备分页');
          if (val.itemsPerPage == -1) {
            this.queryEqpData.pagedQueryInfo.index = 1;
            this.queryEqpData.pagedQueryInfo.pageSize = 99999999;
          } else {
            this.queryEqpData.pagedQueryInfo.index = val.page;
            this.queryEqpData.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          // this.queryEqpList();
        }
      },
      tableOptions: {
        handler(val, old) {
          console.log(val, '数据分页');
          if (val.itemsPerPage == -1) {
            this.queryData.pagedQueryInfo.index = 1;
            this.queryData.pagedQueryInfo.pageSize = 99999999;
          } else {
            this.queryData.pagedQueryInfo.index = val.page;
            this.queryData.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          this.query();
        }
      },
    },
    methods: {
      queryEqpDataList(){
        this.queryEqpData.pagedQueryInfo.index=1;
        this.queryEqpList();
      },
      queryEqpList() {
        console.log(this.queryEqpData, '查找对象');
        this.selectEqp = [];
        historyCollectorQuery(this.queryEqpData).then(res => {
          this.eqpTableData = res.list;
          this.queryEqpData.pagedQueryInfo.sum = res.total;
        }).catch(err => {

        });
      },
      resetEqpQuery() {
        this.$refs.queryEqpData.reset();
        this.queryEqpList();
        this.queryEqpData.pagedQueryInfo.index=1;
        this.queryEqpData.pagedQueryInfo.sum=0;
      },
      allowedStartDates(val) {
        if (!this.queryData.endDate) {
          return Date.parse(val) <= Date.now() - 8.64e7
        } else {
          return Date.parse(this.queryData.endDate) > Date.parse(val) && Date.parse(val) <= Date.now() - 8.64e7;
        }
      },
      allowedDates(val) {
        if (!this.queryData.startDate) {
          return Date.parse(val) <= Date.now() - 8.64e7
        } else {
          return Date.parse(this.queryData.startDate) < Date.parse(val) && Date.parse(val) <= Date.now() - 8.64e7;
        }
      },
      queryHistoryData(){
        this.queryData.pagedQueryInfo.index = 1;
        this.query();
		
      },
      query() {
        console.log(this.queryData, 'queryData');
        // if (this.selectEqp.length < 1) {
        //   return;
        // }
		
        if (this.$refs.queryForm.validate()) {
			console.log('这是自己')
          this.queryData.collectorId = this.antcollectorId||this.selectEqp[0].id;
          if(!this.queryData.isWarning){
            this.queryData.isWarning='';
          }
          collectDetailHistoryController(this.queryData).then(res => {
            this.tableData = res.list;
            this.queryData.pagedQueryInfo.sum = res.total;
          }).catch(err => {

          });
        }
      },
      resetQuery() {
        this.$refs.queryForm.reset();
        this.tableData = [];
        this.queryData.pagedQueryInfo.index=1;
        this.queryData.pagedQueryInfo.sum=0;
      },
      goNextPage() {
        console.log(this.selectEqp[0], '当前选中的设备信息');
        if (this.selectEqp.length < 1) {
          this.$refs.notify.show("未选择绑定对象", {timeout: 1000, color: 'error'})
        } else {
          this.$refs.queryForm.reset();
          this.tableData = [];
          this.stepValue = 2;
          this.loading.selectPlaceLoading = true;
          getSelecotrData('CollectorCollectPlaceSelector', this.selectEqp[0].id).then(res => {
            this.selectOptions = res;
            this.loading.selectPlaceLoading = false;
          }).catch(err => {
            this.loading.selectPlaceLoading = false;
            console.error(err)
          })

        }
      }
    },
    created() {
		if(this.$route.query.stepValue === 2){
		 this.stepValue = this.$route.query.stepValue 
		 this.startDateant = this.$route.query.startTime;
		 this.endDateantL = this.$route.query.endTime;
		 this.antcollectorId = this.$route.query.collectorId;
		 console.log(this.$route.query.collectPlace);
		 this.queryData.collectorPlace = this.$route.query.collectPlace
		
		  getSelecotrData('CollectorCollectPlaceSelector', this.$route.query.collectorId).then(res => {
		    this.selectOptions = res;
		    this.loading.selectPlaceLoading = false;
		  }).catch(err => {
		    this.loading.selectPlaceLoading = false;
		    console.error(err)
		  })
		}
    },
	mounted() {
		console.log("页面已渲染好了")
		this.queryHistoryData();
	}
  }
</script>

<style scoped>

</style>